module.exports = __webpack_public_path__ + "img/fy7.6ec5b0d0.jpg";